<template>
  <form @submit.prevent="createStory">
    <div class="card">
      <div class="card-header">New Project</div>
      <div class="card-body">
        <div class="row">
          <div class="col-8">
            <img
              :src="newStory.imageUrl"
              height="150"
              v-if="newStory.imageUrl"
              alt="preview not available"
            />
            <button
              type="button"
              @click="pickFile"
              class="btn-primary upload-file-button pad-5"
            >
              +</button
            >&nbsp;&nbsp;<span class="text-right pad-top-20">Upload Image</span>
            <input
              type="file"
              style="display: none"
              ref="image"
              accept="image/*"
              @change="onFilePicked"
            />
          </div>
        </div>
        <div class="row pad-top-20">
          <div class="col-8">
            <input
              type="text"
              class="form-control text-field-style"
              v-model="newStory.title"
              placeholder="Project Title"
              required
            />
          </div>
        </div>
        <div class="row pad-top-20">
          <div class="col-8">
            <textarea
              rows="3"
              cols="5"
              class="form-control text-field-style"
              v-model="newStory.subtitle"
              placeholder="Description"
            ></textarea>
          </div>
        </div>
        <!--div class="row pad-top-20">
          <div class="col-8">
            <input
              type="text"
              class="form-control text-field-style"
              v-model="newStory.author"
              placeholder="author"
              required
            />
          </div>
        </div-->
        <div class="row pad-top-20">
          <div class="col-8">
            <input
              type="text"
              class="form-control text-field-style"
              v-model="newStory.organization"
              placeholder="Organization (optional)"
            />
          </div>
        </div>
        <div class="row pad-top-20">
          <div class="col-8">
            <input
              type="text"
              class="form-control text-field-style"
              v-model="newStory.team"
              placeholder="Team (optional)"
            />
          </div>
        </div>
        <div class="row pad-top-20">
          <div class="col-8 flexSpaceBetween text-right">
            <router-link
              :to="{ name: 'projects' }"
              class="btn btn-primary text-field-style"
            >
              Previous
            </router-link>
            <button type="submit" class="btn btn-primary text-field-style">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { db } from "../../../firebaseDB";

let storyRef = db.ref("stories");
export default {
  name: "add-story-1",
  firebase: {
    stories: storyRef,
  },
  data: () => ({
    user: null,
    newStory: {
      id: "",
      title: "",
      subtitle: "",
      organization: "",
      flex: 4,
      author: "",
      team: "",
      topics: [""],
      imageName: "",
      imageUrl: "",
      imageFile: "",
      stepsCompleted: {
        step1: false,
        step2: false,
      },
      isStarred: false,
      date: new Date(Date.now()).toISOString().slice(0, 10),
      diagramData: {
        // { 'key': -3, 'category': 'Create', text: 'Create New', 'loc': '0 0' },
        // nodeDataArray: [{key: 0, title: 'START', category: 'Root', timelineId: ''}],
        nodeDataArray: [{ key: 0, title: "START", category: "Root" }],
        linkDataArray: [],
        universalDataArray: [
          {
            key: 0,
            title: "START",
            category: "Root",
          },
        ],
      },
      nodeContentArray: [""],
    },
  }),
  created() {
    this.user = this.$store.state.user;
    this.allStories = this.$store.state.stories;
    this.newStory.author = this.$store.state.user.firstName + ' ' + this.$store.state.user.lastName;
  },
  methods: {
    createStory() {
      let storyKey;
      if (this.newStory.imageUrl === "") {
        this.newStory.imageUrl =
          //"https://images.pexels.com/photos/860538/pexels-photo-860538.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260";
          "https://firebasestorage.googleapis.com/v0/b/ibegoo-dev.appspot.com/o/new-story.png?alt=media&token=3a71f3b3-a899-423b-8c4e-8684d4b7a793"
      }
      if (this.newStory.author === "") {
        this.newStory.author = this.$store.state.user.firstName + ' ' + this.$store.state.user.lastName;
      }
      // const storiesRef = db.ref().child("stories");
      this.newStory.user_id = this.$store.state.user.id;

      this.$store.state.newStory = this.newStory;

      // storyKey = storiesRef.push(this.newStory).key;
      // this.newStory.id = storyKey;
      // this.$store.dispatch("setNewAddedStoryId", this.newStory.id);
      // localStorage.setItem("storyId", this.newStory.id);
      this.$router.push("/newprofile/add-story/step-2");
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.newStory.imageName = files[0].name;
        if (this.newStory.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.newStory.imageUrl = fr.result;
          this.newStory.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.newStory.imageName = "";
        this.newStory.imageFile = "";
        this.newStory.imageUrl = "";
      }
    },
  },
};
</script>
<style>
.text-field-style {
  border-radius: 6px !important;
}

.upload-file-button {
  width: 30px;
  height: 30px;
  padding: 7px 10px;
  border-radius: 25px !important;
  border: #0a1c0b;
  font-size: 10px;
  text-align: center;
  box-shadow: 1px 1px gainsboro;
}

.flexSpaceBetween {
  display: flex;
  align-items: center;
  justify-content: start;
}

.flexSpaceBetween a {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/add_story/step1.vue